import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { Antwoord, Hersteller, Vraag } from '@models/claims';
import { DataService } from '../../../services/data.service';
import { IBaseVraagboomResultaat, VraagboomAntwoord } from '@models/vragenboom';
import { FormatHelper, SchadeherstelService } from '@services/public_api';
import { takeUntil } from 'rxjs/operators';
import { BaseOlsControlDirective } from '../../base/base-ols-control';

@Component({
  selector: 'app-ruithersteller',
  templateUrl: './ruithersteller.component.html',
  styleUrls: ['./ruithersteller.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RuitherstellerComponent extends BaseOlsControlDirective implements OnInit {
  @Input() vraag: Vraag;
  antwoordUrl = '';
  antwoordTitel: string;
  selectedId = '';
  verz_er_ruit: string[];
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  vraagtitel: string;

  hersteller: Hersteller;
  herstellers: Hersteller[];
  isAuto: boolean;
  kenteken: string;
  overigeTonen: boolean;
  overigeTonenClicked: boolean;
  postcodeRelatie: string;
  postcodeAanwezig: boolean;
  sterrenPresent: boolean;
  geenPreferred: boolean;
  sterrenAanwezig: boolean;
  merkkenteken: string;

  constructor(
    private _dataService: DataService,
    private _schadeherstelService: SchadeherstelService,
  ) {
    super();
  }

  ngOnInit() {
    this.vraagtitel = this.vraag.titel;
    this.postcodeRelatie = this._dataService.getContact()?.postcode;
    if (this.postcodeRelatie?.length >= 4) {
      this.postcodeAanwezig = true;
    } else {
      this.postcodeAanwezig = false;
    }
    this.resultaten$ = this._dataService.resultaten;
    this.resultaten$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res !== undefined && res !== null) {
          this.verwerkResultaten(res);
        }
      });
  }

  verwerkResultaten(resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): void {
    let kenmerken = [];
    let newKenteken = false;
    this.verz_er_ruit = [];
    this.isAuto = false;
    this.overigeTonen = false;
    this.overigeTonenClicked = false;
    this.merkkenteken = '';
    this.vraagtitel = this.vraag.titel;

    for (const resultaat of resultaten) {
      for (const antwoord of resultaat.antwoorden) {
        if (antwoord.tekst_eigenrisico_ruitschade?.length > 0) {
          for (let regel of antwoord.tekst_eigenrisico_ruitschade) {
            regel = regel.replace(/€ /g, '€&nbsp;');
            this.verz_er_ruit.push(regel);
          }
          if (antwoord.kenmerk_titel?.length >= 4) {
            if (antwoord.kenmerk_titel.substring(0, 4).toLocaleLowerCase() === 'auto') {
              this.isAuto = true;
            }
            if (['auto', 'camp'].includes(antwoord.kenmerk_titel.substring(0, 4).toLocaleLowerCase()) && antwoord.kenmerken?.length === 2) {
              if (antwoord.kenmerken[1] !== this.kenteken) {
                this.kenteken = antwoord.kenmerken[1];
                newKenteken = true;
              }

              antwoord.kenmerken.forEach((kenmerk) => {
                this.merkkenteken += kenmerk + " ";
              });
            }
          }
        }
        if (antwoord.kenmerken?.length > 0) {
          kenmerken = antwoord.kenmerken;
          kenmerken.forEach
          this.merkkenteken
        }
      }
    }
    this.vraag.vraagregels.forEach(regel => {
      this.verz_er_ruit.push(regel);
    });
    if (this.vraag?.titel?.length > 0 && kenmerken?.length > 0) {
      if (this.vraag.titel.substring(this.vraag.titel.length - 1) === '.') {
        this.vraagtitel = this.vraag.titel.substring(0, this.vraag.titel.length - 1);
      }
      this.vraagtitel = this.vraagtitel + ': ' + FormatHelper.stringMetSeparator(kenmerken, ' | ') + '.';
    }

    if (this.postcodeAanwezig && newKenteken) {
      // Only calculate schadeherstellers if postcode is available and new kenteken.
      this._schadeherstelService.getSchadeherstellers(this.isAuto, this.kenteken, this.postcodeRelatie.substring(0, 4))
        .pipe(takeUntil(this.unsubscribe$)).subscribe(shb => {
          this.herstellers = [];
          this.geenPreferred = false;

          shb.schadeherstellers.forEach((hersteller: Hersteller) => {
            this.hersteller = hersteller;
            this.hersteller.preferred = false;

            if (hersteller.naam.toLowerCase().replace(/\s/g, '').includes('123ruit')
              || hersteller.naam.toLowerCase().replace(/\s/g, '').includes('autotaalglas')
              || hersteller.naam.toLowerCase().replace(/\s/g, '').includes('kwikfit')) {
              this.hersteller.preferred = true;
            }

            this.hersteller.adres = hersteller.straat + ' ' + hersteller.huisnummer;
            if (hersteller.postcode && hersteller.postcode.length === 6) {
              this.hersteller.postcodeplaats = hersteller.postcode.substring(0, 4) + ' ' + hersteller.postcode.substring(4, 6);
            } else {
              this.hersteller.postcodeplaats = hersteller.postcode;
            }
            this.hersteller.postcodeplaats += ' ' + hersteller.plaats.toUpperCase()
            this.hersteller.googlemaps = "https://www.google.com/maps/search/?api=1&query=" + this.hersteller.adres + ' ' + this.hersteller.postcodeplaats;
            if (hersteller.afstand || hersteller.afstand === 0) {
              this.hersteller.afstandFormat = (hersteller.afstand / 1000).toFixed(1).replace('.', ',') + ' km';
            }
            if (hersteller.telefoonnummer && hersteller.telefoonnummer.length > 0) {
              this.hersteller.telefoonnummer = hersteller.telefoonnummer.replace(/ /g, '');
            }
            if (hersteller.website) {
              if (this.hersteller.website.indexOf('http://') >= 0 || this.hersteller.website.indexOf('https://') >= 0) {
                this.hersteller.website = hersteller.website.toLowerCase();
              } else {
                this.hersteller.website = 'https://' + hersteller.website.toLowerCase();
              }
            }
            this.hersteller.sterren = '';
            if (hersteller.kwalificatie && hersteller.kwalificatie.length > 0) {
              this.hersteller.sterren = 'sterren' + hersteller.kwalificatie.substring(0, 1);
              this.sterrenAanwezig = true;
            }
            this.herstellers.push(this.hersteller);
          });
          if (this.herstellers.findIndex(h => h.preferred) < 0) {
            this.geenPreferred = true;
          }
        })
    }
  }

  iconlocation(icon: string): string {
    return '/assets/icons/ols/' + icon + '.svg';
  }

  geefTekstKnop() {
    if (this.antwoordTitel) {
      return this.vraag.button_text + ' ' + this.antwoordTitel;
    }
    return this.vraag.button_text;
  }

  onClickAntwoord(antwoord: Antwoord): void {
    this.antwoordTitel = antwoord.titel;
    this.selectedId = antwoord.id;
    if (antwoord.antwoordregels?.length > 0) {
      this.antwoordUrl = antwoord.antwoordregels[0];
    }
  }

  geefSterren(hersteller: Hersteller): string {
    if (hersteller.kwalificatie && hersteller.kwalificatie.length > 0) {
      this.sterrenPresent = true;
      return hersteller.kwalificatie.substring(0, 1);
    }
    return '';
  }

  naarGlashersteller(): void {
    if (this.selectedId !== '' && this.antwoordUrl?.length > 0) {
      window.open(this.antwoordUrl, '_blank');
    }
  }

  naarHerstellerTool(): void {
    window.open('/service/schadeherstelbedrijven', '_blank');
  }

  geefPazaProces(): string {
    return this._dataService.getMeetidPazaProces();
  }
}
